import classNames from "classnames";
import { ArrowIcon } from "@/shared/icons/ArrowIcon";
import { DoubleArrowIcon } from "@/shared/icons/DoubleArrowIcon";
import { AppButton } from "@/shared/Components/AppButton";
import type { FC } from "react";
import styles from "./styles.module.scss";

type Props = {
  position?: "right" | "left";
  onOneArrowClick: () => void;
  onDoubleArrowClick: () => void;
};

export const Arrows: FC<Props> = ({ onDoubleArrowClick, onOneArrowClick, position = "left" }) => {
  return (
    <div className={classNames(styles.arrows, styles[position])}>
      <AppButton onClick={onDoubleArrowClick} type="text" className={styles["icon-button"]}>
        <DoubleArrowIcon />
      </AppButton>
      <AppButton onClick={onOneArrowClick} type="text" className={styles["icon-button"]}>
        <ArrowIcon />
      </AppButton>
    </div>
  );
};
